import { format } from 'date-fns';

/**
 * Formats a date string to a readable format
 * @param {string} dateString - The date string to format
 * @returns {string} Formatted date string or 'N/A' if invalid
 */
export const formatDate = (dateString) => {
  if (!dateString) return 'N/A';
  
  try {
    return format(new Date(dateString), 'dd/MM/yyyy HH:mm');
  } catch (error) {
    console.error('Date formatting error:', error);
    return dateString;
  }
};

/**
 * Formats a date string to show only the date
 * @param {string} dateString - The date string to format
 * @returns {string} Formatted date string or 'N/A' if invalid
 */
export const formatDateOnly = (dateString) => {
  if (!dateString) return 'N/A';
  
  try {
    return format(new Date(dateString), 'dd/MM/yyyy');
  } catch (error) {
    console.error('Date formatting error:', error);
    return dateString;
  }
}; 